var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 5H5C3.61929 5 2.5 6.11929 2.5 7.5V27.5C2.5 28.8807 3.61929 30 5 30H35C36.3807 30 37.5 28.8807 37.5 27.5V7.5C37.5 6.11929 36.3807 5 35 5Z",
    stroke: "#7E898F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 35L23.125 30H16.875L16.25 35H23.75Z",
    fill: "#7E898F",
    stroke: "#7E898F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 35H11.25",
    stroke: "#7E898F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 23.75V27.5C2.50186 28.1625 2.76584 28.7973 3.23428 29.2657C3.70272 29.7342 4.33753 29.9981 5 30H35C35.6625 29.9981 36.2973 29.7342 36.7657 29.2657C37.2342 28.7973 37.4981 28.1625 37.5 27.5V23.75H2.5ZM20 28.75C19.7528 28.75 19.5111 28.6767 19.3055 28.5393C19.1 28.402 18.9398 28.2068 18.8451 27.9784C18.7505 27.7499 18.7258 27.4986 18.774 27.2561C18.8223 27.0137 18.9413 26.7909 19.1161 26.6161C19.2909 26.4413 19.5137 26.3222 19.7561 26.274C19.9986 26.2258 20.2499 26.2505 20.4784 26.3452C20.7068 26.4398 20.902 26.6 21.0393 26.8055C21.1767 27.0111 21.25 27.2528 21.25 27.5C21.25 27.8315 21.1183 28.1495 20.8839 28.3839C20.6495 28.6183 20.3315 28.75 20 28.75Z",
    fill: "#7E898F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopOutline);
export default __webpack_public_path__ + "static/media/desktop-outline.ef95867859bbd0dbe2998621d5976cd5.svg";
export { ForwardRef as ReactComponent };